//General
export const formatId = (id) => {
  let reformattedId = "Not Set";

  if (id) {
    reformattedId = id
      .replace("BID", "")
      .replace("UID", "")
      .replace("DEL", "")
      .replace("STO", "")
      .replace("ORD", "")
      .replace("OIT", "")
      .replace("DIT", "")
      .replace("WOR", "")
      .replace("WIT", "")
      .replace("SIT", "")
      .replace(/^0+/, "");
  }

  return reformattedId;
};

export const formatDate = (date, format) => {
  let reformattedDate = "Not Set";

  if (date) {
    reformattedDate = JSON.stringify(date)
      .replace(/"/g, "")
      .replace("T", " ")
      .replace("Z", "");
    if (reformattedDate.includes("+")) {
      reformattedDate = reformattedDate.slice(0, -6);
    }
    var day = "";
    var month = "";
    var year = "";
    var hour = "";
    var minute = "";
    var second = "";

    switch (format) {
      case "YYYYMMDDHHMMSS":
        reformattedDate = reformattedDate.slice(0, -4);
        break;

      case "YYYYMMDDHHMM":
        reformattedDate = reformattedDate.slice(0, -7);
        break;

      case "YYYYMMDDHH":
        reformattedDate = reformattedDate.slice(0, -10);
        break;

      case "YYYYMMDD":
        reformattedDate = reformattedDate.slice(0, -13);
        break;

      case "YYMMDD":
        reformattedDate = reformattedDate.slice(2, -13);
        break;

      case "DDMMYY":
        day = reformattedDate.slice(8, -13);
        month = reformattedDate.slice(5, -16);
        year = reformattedDate.slice(2, -19);
        reformattedDate = day + "-" + month + "-" + year;
        break;
      case "DDMMYYYY":
        day = reformattedDate.slice(8, -13);
        month = reformattedDate.slice(5, -16);
        year = reformattedDate.slice(0, -19);
        reformattedDate = day + "-" + month + "-" + year;
        break;

      case "DDMMYYYYHHMMSS":
        day = reformattedDate.slice(8, -13);
        month = reformattedDate.slice(5, -16);
        year = reformattedDate.slice(0, -19);
        hour = reformattedDate.slice(11, -10);
        minute = reformattedDate.slice(14, -7);
        second = reformattedDate.slice(17, -4);
        reformattedDate =
          day +
          "-" +
          month +
          "-" +
          year +
          " " +
          hour +
          ":" +
          minute +
          ":" +
          second;
        break;

      case "DDMMYYYYHHMM":
        day = reformattedDate.slice(8, -13);
        month = reformattedDate.slice(5, -16);
        year = reformattedDate.slice(0, -19);
        hour = reformattedDate.slice(11, -10);
        minute = reformattedDate.slice(14, -7);
        reformattedDate =
          day + "-" + month + "-" + year + " " + hour + ":" + minute;
        break;

      case "DDMMYYYYHH":
        day = reformattedDate.slice(8, -13);
        month = reformattedDate.slice(5, -16);
        year = reformattedDate.slice(0, -19);
        hour = reformattedDate.slice(11, -10);
        reformattedDate = day + "-" + month + "-" + year + " " + hour;
        break;

      default:
    }
  }

  return reformattedDate;
};
export const formatDateFromTime = (time) => {
  let reformattedDate = "Not Set";

  let date = new Date();
  let dateBeginning = "";
  let dateEnd = "";
  if (date) {
    reformattedDate = JSON.stringify(date).replace(/"/g, "");

    dateBeginning = reformattedDate.slice(0, -13);
    dateEnd = reformattedDate.slice(16);
    reformattedDate = dateBeginning + time + dateEnd;
  }
  reformattedDate = new Date(reformattedDate);
  return reformattedDate;
};

export const isNotNull = (object) => {
  if (object === null) {
    return false;
  }
  if (object === undefined) {
    return false;
  }
  if (Array.isArray(object) && object.length === 0) {
    return false;
  }
  if (object === "") {
    return false;
  }
  if (object === "undefined") {
    return false;
  }

  return true;
};

export const formatValue = (value, decimalPlaces) => {
  if (!isNotNull(decimalPlaces)) {
    decimalPlaces = 2;
  }
  if (!isNotNull(value)) {
    value = 0;
  }
  console.log("formatValue", value);
  return parseFloat(value).toFixed(decimalPlaces);
  // return parseFloat(value);
};



// WEBPACK FOOTER //
// ./src/common/FormatFunctions.js